import { useCallback, useEffect, useState } from "react";

/*
  대시보드 개편안이 쓰는 안전 데이터 한 묶음.

  /api/safety-report 한 번으로 아래를 전부 받는다 — 화면마다 따로 부르면
  같은 요청이 네 번씩 나가던 예전 문제를 반복한다.
    · summary.complianceRate / prevComplianceRate  → 준수율 게이지
    · daily[]                                       → 7일 추이
    · byItem[]                                      → 위반 항목별
    · byHour[]                                      → 시간대별 분포
    · violations[]                                  → 오늘 위반 목록(미확인 = status "open")

  기간이 둘이라 두 번 부른다. 오늘(목록·항목·시간대)과 최근 7일(추이·준수율).
*/
function pad2(n) {
  return String(n).padStart(2, "0");
}
function isoOf(dt) {
  return `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
}

async function getReport(from, to, limit) {
  const res = await fetch(
    `/api/safety-report?from=${from}&to=${to}&site=all&limit=${limit}`,
    { credentials: "include", cache: "no-store" }
  );
  if (!res.ok) throw new Error(`safety-report ${res.status}`);
  return res.json();
}

export default function useSafetyOverview({ enabled = true, refreshMs = 30000 } = {}) {
  const [today, setToday] = useState(null);
  const [week, setWeek] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    if (!enabled) return;
    try {
      const now = new Date();
      const todayIso = isoOf(now);
      const weekAgo = new Date(now);
      weekAgo.setDate(weekAgo.getDate() - 6);

      const [t, w] = await Promise.all([
        getReport(todayIso, todayIso, 200),
        getReport(isoOf(weekAgo), todayIso, 1),
      ]);

      setToday(t);
      setWeek(w);
      setFailed(false);
    } catch {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    load();
    if (!refreshMs) return undefined;
    const t = setInterval(load, refreshMs);
    return () => clearInterval(t);
  }, [enabled, load, refreshMs]);

  return { today, week, loading, failed, reload: load };
}
